import React, { FC } from 'react'
import * as StyledErrorMessage from './errorMessage.styles'
import { PageContainer } from 'components/base/grid/grid'
import { Flex } from 'rebass'
import { H2 } from 'components/base/typography/headings'
import { PLarge } from 'components/base/typography/misc'

interface Props {
	title: string
	text: string
}

const ErrorMessage: FC<Props> = ({ title, text }) => {
	return (
		<StyledErrorMessage.Wrapper>
			<PageContainer>
				<Flex
					alignItems="center"
					flexDirection="column"
					style={{ textAlign: 'center', maxWidth: '60rem', margin: '10vh auto 10vh auto' }}>
					<H2 mb="4.5rem">{title}</H2>
					<PLarge>{text}</PLarge>
				</Flex>
			</PageContainer>
		</StyledErrorMessage.Wrapper>
	)
}

export default ErrorMessage
